import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Footer from "./Components/Footer/Footer";
import Navbar from "./Components/Navbar/Navbar";
import Home from "./Pages/Home/Home";
import Signup from "./Pages/Signup/Signup";
import Signin from "./Pages/Signin/Signin";
import ProtectedRoute from "./Components/ProtectedRoute/ProtectedRoute";
import EmailVerification from "./Pages/EmailVerification/EmailVerification";
import Profile from "./Pages/Profile/Profile";
import PageNotFound from "./Pages/PageNotFound/PageNotFound";
import SingleBlog from "./Pages/Blog/SingleBlog";
import WriteBlog from "./Pages/Blog/WriteBlog";
import UpdateBlog from "./Pages/Blog/UpdateBlog";
import Blogs from "./Pages/Blog/Blogs";
import BlogByUser from "./Pages/Blog/BlogByUser";
import OtherUserProfile from "./Pages/Profile/OtherUserProfile";

const App = () => {
  const token = JSON.parse(localStorage.getItem("WM:user-token"));
  return (
    <>
      <Router>
        <ToastContainer
          position="top-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          theme="dark"
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover={false}
        />
        <Navbar />
        <Routes>
          <Route element={<ProtectedRoute token={token} />}>
            <Route path="/profile" element={<Profile />} />
            <Route path="/other-user/:id" element={<OtherUserProfile />} />
            <Route path="/write-blog" element={<WriteBlog />} />
            <Route path="/update-blog/:id" element={<UpdateBlog />} />
          </Route>

          <Route path="/" element={<Home />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/signin" element={<Signin />} />
          <Route path="/verify-email" element={<EmailVerification />} />
          <Route path="/blog-details/:id" element={<SingleBlog />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog-by-user/:id" element={<BlogByUser />} />

          <Route path="*" element={<PageNotFound />} />
        </Routes>
        <Footer />
      </Router>
    </>
  );
};

export default App;
